

















import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { FileType } from '../../types'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class FileTypeButton extends Vue {
  @Prop() fileType!: { type: FileType, icon: string, subType: string, disabled: boolean }

  @Emit()
  setFileType(): { type: FileType, subType: string } | null {
    if (!this.fileType.disabled) {
      return { type: this.fileType.type, subType: this.fileType.subType }
    }

    return null
  }
}
